<template>
  <el-switch
      v-if="isEditable ? hasBrowsePagePermission : hasEditPagePermission"
      :value="isEditable"
      @change="handleModeChange"
      active-text="編集"
      active-color="#1976d2"
      inactive-text="閲覧"
      inactive-color="#16b94f">
  </el-switch>
</template>

<script>
import PathInfoMixin from "@/router/PathInfoMixin";
import PermissionMixin from "@/utils/PermissionMixin";

export default {
  name: "EditToggleButton",
  mixins: [ PathInfoMixin, PermissionMixin ],
  props: {
    componentName: {
      type: String,
      required: true,
    },
  },
  computed: {
    browsePageLocation() {
      return {name: this.alterRouteName(this.componentName, 'browse')};
    },
    editPageLocation() {
      return {name: this.alterRouteName(this.componentName, 'edit')};
    },
    hasBrowsePagePermission() {
      return this.hasPagePermission(this.browsePageLocation, 'browse');
    },
    hasEditPagePermission() {
      return this.hasPagePermission(this.editPageLocation, 'edit');
    },
  },
  methods: {
    handleModeChange(isEditable) {
      this.$emit('change', isEditable ? 'edit' : 'browse');
      this.$router.push(isEditable ? this.editPageLocation : this.browsePageLocation);
    }
  }
}
</script>

<style lang="scss" scoped>
label {
  margin-left: 0.5rem;
}

.v-btn.v-btn--outlined {
  color: rgba(0,0,0,0.54);
  border-color: rgba(0,0,0,0.2);

  label {
    color: rgba(0,0,0,0.8);
  }
}

::v-deep .el-switch__label.is-active {
  color: inherit;
}
</style>
